export default "__VITE_ASSET__DYXvarxv__"